<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb62></breadcrumb62>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar1></sidebar1>
                </div>

                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>

                <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                  <div class="ml-md-4">
                    <div class="container p-3" style="background-color:#f8f8f8;">
                      <b-tabs active-nav-item-class="font-weight-bold text-white bg-success" content-class="mt-3"
                        align="center">
                        <b-card-group deck>
                          <b-tab title="Training Video in English" active>
                            <div class="container">

                              <div class="row">
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">1</span>
                                      <img src="@/assets/img/register_patient.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">Register a New Patient</h4>
                                      <p class="card-description" style="height:150px;">Registration is must for seeking
                                        Appointment with listed Doctors.</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openEngWaVideoPopup(0)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openWebVideoPopup(0)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">2</span>
                                      <img src="@/assets/img/Add_doctor_to_Fav.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">Add a Doctor to Favorite</h4>
                                      <p class="card-description" style="height:150px;">Build a list of your Favourite
                                        Doctors listed here. On an Appointment with a Doctor , System adds it to your
                                        Favourite for future easy Appointments.</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openEngWaVideoPopup(1)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openWebVideoPopup(1)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">3</span>
                                      <img src="@/assets/img/Booked_appointment.png" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">Appointment Booking</h4>
                                      <p class="card-description" style="height:150px;">Patient can booked there
                                        appointment according to preferred time slots.</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openEngWaVideoPopup(2)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openWebVideoPopup(2)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">4</span>
                                      <img src="@/assets/img/Record_vitals.jpg" alt="logo" class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">Record Self Vital Sign</h4>
                                      <p class="card-description" style="height:150px;">Self Record Vital Signs for
                                        Self/Doctor Monitoring.</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openEngWaVideoPopup(3)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openWebVideoPopup(3)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">5</span>
                                      <img src="@/assets/img/Upload_a_Medical_Record.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">Upload a Medical Record</h4>
                                      <p class="card-description" style="height:150px;">Upload medical records for easy
                                        sharing with any doctor.</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openEngWaVideoPopup(4)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openWebVideoPopup(4)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">6</span>
                                      <img src="@/assets/img/share_medical_record.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">Share a Medical Record</h4>
                                      <p class="card-description" style="height:150px;">Share Medical Records immediately
                                        after Appointment or Share from your Medical Record Repository.</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openEngWaVideoPopup(5)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openWebVideoPopup(5)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">7</span>
                                      <img src="@/assets/img/add_family_member.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">Update Profile and Information</h4>
                                      <p class="card-description" style="height:150px;">Seamlessly Update Your Information.</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openEngWaVideoPopup(6)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openWebVideoPopup(6)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">8</span>
                                      <img src="@/assets/img/Reschedule_an_Appointment.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">Reschedule an Appointment</h4>
                                      <p class="card-description" style="height:150px;">Reschedule an appointment, if you
                                        are not able to make it on time.</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openEngWaVideoPopup(7)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <!-- <button class="btn btn-white m-1"><i class="fas fa-globe"></i> Web App</button> -->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">9</span>
                                      <img src="@/assets/img/cancel_appointment.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">Cancel an Appointment</h4>
                                      <p class="card-description" style="height:150px;">Cancel an Appointment, if you are
                                        not interested to make it.</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openEngWaVideoPopup(8)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <!-- <button class="btn btn-white m-1" @click="openWebVideoPopup(4)"><i class="fas fa-globe"></i> Web App</button> -->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">10</span>
                                      <img src="@/assets/img/add_family_member.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">Add a Family Member</h4>
                                      <p class="card-description" style="height:150px;">Add a family member to your
                                        dependent list for easy referring, in case of emergency.</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openEngWaVideoPopup(9)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openWebVideoPopup(7)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-tab>
                          <b-tab title="हिंदी में प्रशिक्षण वीडियो">
                            <div class="container">
                              <div class="row">
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">1</span>
                                      <img src="@/assets/img/register_patient.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">नए रोगी को पंजीकृत करें</h4>
                                      <p class="card-description" style="height:150px;">निर्दिष्ट डॉक्टर के साथ साक्षात्कार के लिए पंजीकरण अनिवार्य है ।</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openWaVideoPopup(0)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openVideoPopup(0)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">2</span>
                                      <img src="@/assets/img/Add_doctor_to_Fav.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">पसंदीदा डॉक्टर को जोड़ें</h4>
                                      <p class="card-description" style="height:150px;">यहां सूचीबद्ध डॉक्टरों के साथ एक साक्षात्कार के लिए पंजीकरण करें। डॉक्टर के साथ एक साक्षात्कार के बाद, सिस्टम आपको भविष्य के सरल समय के लिए इसे आपके पसंदीदा में जोड़ देता है ।</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openWaVideoPopup(1)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openVideoPopup(1)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">3</span>
                                      <img src="@/assets/img/Booked_appointment.png" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">नियुक्ति बुकिंग</h4>
                                      <p class="card-description" style="height:150px;">रोगी पसंदीदा समय स्लॉट के अनुसार अपना समय बुक कर सकता है ।</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openWaVideoPopup(2)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openVideoPopup(2)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">4</span>
                                      <img src="@/assets/img/Record_vitals.jpg" alt="logo" class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">स्व वाइटल संकेत दर्ज करें</h4>
                                      <p class="card-description" style="height:150px;">स्व या डॉक्टर मॉनिटरिंग के लिए स्व रेकॉर्ड वाइटल साइन्स दर्ज करें</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openWaVideoPopup(3)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openVideoPopup(3)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">5</span>
                                      <img src="@/assets/img/Upload_a_Medical_Record.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">चिकित्सा रेकॉर्ड अपलोड करें</h4>
                                      <p class="card-description" style="height:150px;">किसी भी डॉक्टर के साथ साझा करने के लिए चिकित्सा रेकॉर्ड अपलोड करें</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openWaVideoPopup(4)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openVideoPopup(4)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">6</span>
                                      <img src="@/assets/img/share_medical_record.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">चिकित्सा रेकॉर्ड साझा करें</h4>
                                      <p class="card-description" style="height:150px;">अपॉइंटमेंट के बाद तुरंत चिकित्सा रेकॉर्ड साझा करें या अपने चिकित्सा रेकॉर्ड रिपॉज़िटरी से साझा करें</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openWaVideoPopup(5)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openVideoPopup(5)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">7</span>
                                      <img src="@/assets/img/add_family_member.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">पेशेंन्ट प्रोफ़ाइल अपडेट करें</h4>
                                      <p class="card-description" style="height:150px;">अपनी निजी इन्फॉर्मेशन डिटेल में अपडेट करें।</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openWaVideoPopup(6)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openVideoPopup(6)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">8</span>
                                      <img src="@/assets/img/Reschedule_an_Appointment.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">नियुक्ति पुनः तय करें</h4>
                                      <p class="card-description" style="height:150px;">समय पर नहीं पहुंच पा रहे हैं तो नियुक्ति पुनः तय करें</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openWaVideoPopup(7)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <!-- <button class="btn btn-white m-1"><i class="fas fa-globe"></i> Web App</button> -->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">9</span>
                                      <img src="@/assets/img/cancel_appointment.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">नियुक्ति रद्द करें</h4>
                                      <p class="card-description" style="height:150px;">अगर आप इसे बनाने में रुचि नहीं रखते हैं, तो नियुक्ति रद्द करें</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openWaVideoPopup(8)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <!-- <button class="btn btn-white m-1" @click="openVideoPopup(4)"><i class="fas fa-globe"></i> Web App</button> -->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-4 col-12">
                                  <div class="demo-video-card-container">
                                    <div class="demo-video-card p-3">
                                      <span class="badge badge-pill badge-primary"
                                        style="position: absolute; top: 10px; right: 10px;">10</span>
                                      <img src="@/assets/img/add_family_member.jpg" alt="logo"
                                        class="appointment_modal_logo"
                                        style="width: 80px; height: 80px; border-radius:100%;" />
                                      <h4 class="card-heading mt-3" style="font-weight: bold;">परिवार के सदस्य को जोड़ें</h4>
                                      <p class="card-description" style="height:150px;">आपके निर्भर सूची के लिए एक परिवार सदस्य जोड़ें, आपातकाल में संदर्भ के लिए सरलता से</p>
                                      <div class="card-buttons justify-content-center">
                                        <button class="btn btn-white m-1" @click="openWaVideoPopup(9)"><i
                                            class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA
                                          Bot</button>
                                        <button class="btn btn-white m-1" @click="openVideoPopup(7)"><i
                                            class="fas fa-globe"></i> Web App</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-tab>
                        </b-card-group>
                      </b-tabs>
                      <div v-if="isVideoPopupVisible" class="video-popup">
                        <span class="close-popup" @click="closeVideoPopup">&times;</span>
                        <iframe :src="currentVideoUrl" width="600" height="380" frameborder="0"
                          allow="autoplay; fullscreen" allowfullscreen></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import CommonApi from "@/services/CommonApi";
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
const images = require.context("@/assets/img/patients");
const doctorimages = require.context("@/assets/img/doctors");

export default {

  data() {
    return {
      isVideoPopupVisible: false,
      videoUrls: [
        "https://www.youtube.com/embed/XtBxJCENUCs",
        "https://www.youtube.com/embed/jphtemugSW8",
        "https://www.youtube.com/embed/Rl7iTUW4RT8",
        "https://www.youtube.com/embed/8NP43kxheGE",
        "https://www.youtube.com/embed/nGl04WMHkJU",
        "https://www.youtube.com/embed/c5cz0HHnYDI",
        "https://www.youtube.com/embed/PMOhLoA4Nsk",
        "https://www.youtube.com/embed/PtMWY_UQwAs",
      ],

      EngWebVideoUrls: [
        "https://www.youtube.com/embed/j7yt_jtbuns?si=sArAc9nHSxb5IgTb",
        "https://www.youtube.com/embed/r_14yW9nloQ?si=hvu5kbm1ZDKG1GLO",
        "https://www.youtube.com/embed/f6t6zH_3tpE?si=TpPB20SFjxlJ76yN",
        "https://www.youtube.com/embed/0C01S7O1sKk?si=guLIjdAXjXt6jos9",
        "https://www.youtube.com/embed/hcuk0WXxqdI?si=EeyEC6woOLjBb3Ky",
        "https://www.youtube.com/embed/-OHS5gr11Ok?si=j69mgEFN7UD51s7k",
        "https://www.youtube.com/embed/O3tQGte-9V4",
        "https://www.youtube.com/embed/UaiKeLejkgw?si=iE0DVQ7WT-NYDBhC",
      ],

      videoUrls1: [
        "https://www.youtube.com/embed/qzGvUGiPTl8?si=feozWi9-V77LyDBe",
        "https://www.youtube.com/embed/F7glzA7P5mU?si=4X8SM3YFaacVJlSF",
        "https://www.youtube.com/embed/SLZfRzsRTMU?si=FA-11fdo2fhmUC8v",
        "https://www.youtube.com/embed/D-EEk5Dktho?si=C3xDOVAvkbJOwN_A",
        "https://www.youtube.com/embed/p8PreP9Nch4?si=8xDUMsHC1kNWe9DG",
        "https://www.youtube.com/embed/27n6QwX47iE?si=ScR8YC8ByxED8UNS",
        "https://www.youtube.com/embed/nKuErgHp0go",
        "https://www.youtube.com/embed/VvZ5ayN8xHo",
        "https://www.youtube.com/embed/CVlUEJ9oLZo",
        "https://www.youtube.com/embed/JzzV8qFLYBw",
      ],

      EngWavideoUrls: [
        "https://www.youtube.com/embed/72Hy2hbotNo?si=Tzc_izZHbTyx2cIE",
        "https://www.youtube.com/embed/CkosHhGJEYY?si=JRxhFqgVv9rUzl2G",
        "https://www.youtube.com/embed/vn4ReTxp5co?si=lVfZQcUr9y75V6cN",
        "https://www.youtube.com/embed/X-an825PCh0?si=Ftf8UE2nFTHv1JKi",
        "https://www.youtube.com/embed/h4gz8U9dUO0?si=vgHkDI0RHYJSNSyQ",
        "https://www.youtube.com/embed/BM7wUdGrQOA?si=drGfDjtLGxktT0fN",
        "https://www.youtube.com/embed/cE1ZCWWJ8PQ",
        "https://www.youtube.com/embed/44npO13h6Ag?si=B8mBtj934c81_yax",
        "https://www.youtube.com/embed/-pLAqD5ah7w?si=VHXYUPX4ato0IObB",
        "https://www.youtube.com/embed/8xHUMmuxXdU?si=euqMZ1VMb2QbTlRR"
      ],
    };
  },
  mounted() {
  },
  computed: {
  },

  methods: {
    openVideoPopup(index) {
      // Open the video popup with the corresponding video URL
      this.isVideoPopupVisible = true;
      this.currentVideoUrl = this.videoUrls[index];
    },

    openWebVideoPopup(index) {
      // Open the video popup with the corresponding video URL
      this.isVideoPopupVisible = true;
      this.currentVideoUrl = this.EngWebVideoUrls[index];
    },

    openWaVideoPopup(index) {
      // Open the video popup with the corresponding video URL
      this.isVideoPopupVisible = true;
      this.currentVideoUrl = this.videoUrls1[index];
    },

    openEngWaVideoPopup(index) {
      // Open the video popup with the corresponding video URL
      this.isVideoPopupVisible = true;
      this.currentVideoUrl = this.EngWavideoUrls[index];
    },
    closeVideoPopup() {
      // Close the video popup
      this.isVideoPopupVisible = false;
    },
  }
}
</script>

<style>.video-popup {
  display: block;
  position: fixed;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.close-popup {
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 30px;
  cursor: pointer;
  color: black;
}

.close-popup:hover {
  color: #ff0000;
}

.demo-video-card-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  /* Ensure the container takes full height */
  position: relative;
}

.demo-video-card {
  border-radius: 10px;
  background-color: white;
  transition: background-color 0.5s;
  /* Add a smooth transition effect */
  flex: 1;
  /* Expand to take remaining space */
}

.demo-video-card:hover {
  background-color: #397370;
}

.card-buttons {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  /* Semi-transparent background */
  transition: background-color 0.5s;
  /* Add a smooth transition effect */
}

.card-buttons button:hover {
  background-color: #66cdaa;
  /* Change the background color on hover */
  color: white;
  /* Change the text color on hover */
  transform: scale(1.1);
  /* Increase the size on hover */
}

.demo-video-card-container:hover .card-buttons {
  background-color: rgba(57, 115, 112, 0.8);
  /* Semi-transparent background on hover */
}

.new_btn:hover {
  background-color: #10553e;
}

.demo-video-card-container:hover .card-heading,
.demo-video-card-container:hover .card-description {
  color: white;
}</style>


// WEBPACK FOOTER //
// src/components/kneexpert/patient/OnBoarding.vue